export default __webpack_public_path__ + "static/media/whatsapp-icon.e8bd880e.svg";